import { GET } from "../../../helpers/restFunction";

const GetJobStatus = async (userId: string) => {
  const path = `/cad/users/${userId}/read_projects`;
  return await GET(path)
    .then((result) => {
      return result[1];
    })
    .catch((err) => {
      console.log("error on fetching objective >", err);
      return err;
    });
};
export default GetJobStatus;
